import { aboutMontessori } from './entries/about-montessori';
import { appearsOnRadio202311 } from './entries/appears-on-radio202311';
import { babyAndMammyReOpening } from './entries/baby-and-mammy-re-opening';
import { babyFollowingUntil } from './entries/baby-following-until';
import { babyFollowingWhen } from './entries/baby-following-when';
import { babyNightCrying } from './entries/baby-night-crying';
import { babyNotFollowing } from './entries/baby-not-following';
import { bedtimeAge2 } from './entries/bedtime-age2';
import { childPersonalityDiagnosis } from './entries/child-personality-diagnosis';
import { childcareConsultationChat } from './entries/childcare-consultation-chat';
import { chopsticksPractice } from './entries/chopsticks-practice';
import { clayPlayIdeasAge2 } from './entries/clay-play-ideas-age2';
import { concentration } from './entries/concentration';
import { cupDrinkingPractice } from './entries/cup-drinking-practice';
import { curiosity } from './entries/curiosity';
import { fourYearOldTantrums } from './entries/four-year-old-tantrums';
import { fourYearsOldEquipment } from './entries/four-years-old-equipment';
import { handmadeMontessoriToys } from './entries/handmade-montessori-toys';
import { hoikuKyoikuHoushinChigai } from './entries/hoiku-kyoiku-houshin-chigai';
import { hoikuenErabikata } from './entries/hoikuen-erabikata';
import { hoikuenMoushikomiItsukara } from './entries/hoikuen-moushikomi-itsukara';
import { hoikuenNaraigoto } from './entries/hoikuen-naraigoto';
import { hoikuenSagashikata } from './entries/hoikuen-sagashikata';
import { hoikuen3saiKara } from './entries/hoikuen3sai-kara';
import { hokatsuItsukara } from './entries/hokatsu-itsukara';
import { howToScoldChild } from './entries/how-to-scold-child';
import { hundredYenMontessori } from './entries/hundred-yen-montessori';
import { independence } from './entries/independence';
import { indoorExercisePlayAge1 } from './entries/indoor-exercise-play-age1';
import { indoorExercisePlayAge2 } from './entries/indoor-exercise-play-age2';
import { indoorPlay2YearsOld } from './entries/indoor-play2-years-old';
import { indoorPlay3YearsOld } from './entries/indoor-play3-years-old';
import { installHomeMonte } from './entries/install-home-monte';
import { iyaiya } from './entries/iyaiya';
import { montessoriHoikuenDemerit } from './entries/montessori-hoikuen-demerit';
import { montessoriMathEducationForEducators } from './entries/montessori-math-education-for-educators';
import { napRefusalAge2 } from './entries/nap-refusal-age2';
import { narashiHoikuKikan } from './entries/narashi-hoiku-kikan';
import { naturalWeaning } from './entries/natural-weaning';
import { newbornBedtime } from './entries/newborn-bedtime';
import { nurseryAdmissionPrep } from './entries/nursery-admission-prep';
import { nurseryCostComparison } from './entries/nursery-cost-comparison';
import { nurseryFeeExemptionUnlicensed } from './entries/nursery-fee-exemption-unlicensed';
import { nurseryMidYearAdmission } from './entries/nursery-mid-year-admission';
import { nurseryRejectionWhatToDo } from './entries/nursery-rejection-what-to-do';
import { nurseryReluctance } from './entries/nursery-reluctance';
import { nurseryTransfer } from './entries/nursery-transfer';
import { nurseryUnlicensedDemerit } from './entries/nursery-unlicensed-demerit';
import { nurseryVisitChecklist } from './entries/nursery-visit-checklist';
import { nurseryVisitOutfit } from './entries/nursery-visit-outfit';
import { nurseryVisitQuestions } from './entries/nursery-visit-questions';
import { olderSiblingFeelings } from './entries/older-sibling-feelings';
import { oneYearOldEquipment } from './entries/one-year-old-equipment';
import { oneYearOldPlunk } from './entries/one-year-old-plunk';
import { oneYearsOldDrawing } from './entries/one-years-old-drawing';
import { otetsudaiAge2 } from './entries/otetsudai-age2';
import { parentingConsultation } from './entries/parenting-consultation';
import { parentingIraira } from './entries/parenting-iraira';
import { parentingNeurosis } from './entries/parenting-neurosis';
import { parentingTired } from './entries/parenting-tired';
import { parentingTsurai } from './entries/parenting-tsurai';
import { peAndEurhymics202507 } from './entries/pe-and-eurhymics_202507';
import { pickyEatingChild } from './entries/picky-eating-child';
import { placeAnxiety } from './entries/place-anxiety';
import { plannedWeaning } from './entries/planned-weaning';
import { playingWithFood } from './entries/playing-with-food';
import { readAloudEffect } from './entries/read-aloud-effect';
import { resolvingParentingIssues } from './entries/resolving-parenting-issues';
import { restless3YearOld } from './entries/restless3-year-old';
import { selfCorrection } from './entries/self-correction';
import { selfEsteemChild } from './entries/self-esteem-child';
import { selfSettlingSleep } from './entries/self-settling-sleep';
import { sensitivePeriods } from './entries/sensitive-periods';
import { separationAnxietyElementarySchool } from './entries/separation-anxiety-elementary-school';
import { separationAnxietyNursery } from './entries/separation-anxiety-nursery';
import { sessionInformation202310 } from './entries/session-information202310';
import { sessionInformation202409 } from './entries/session-information202409';
import { sessionInformation202410 } from './entries/session-information202410';
import { sessionInformation202509 } from './entries/session-information202509';
import { sessionInformation202609 } from './entries/session-information202609';
import { sessionInformation202610 } from './entries/session-information202610';
import { smallClassNursery } from './entries/small-class-nursery';
import { soloParentingMontessori } from './entries/solo-parenting-montessori';
import { speechDelayAge2 } from './entries/speech-delay-age2';
import { spoonPractice } from './entries/spoon-practice';
import { strangerAnxietyWhen } from './entries/stranger-anxiety-when';
import { tantrum2YearOld } from './entries/tantrum2-year-old';
import { tantrum3YearOld } from './entries/tantrum3-year-old';
import { tantrumsSelfWill } from './entries/tantrums-self-will';
import { threeYearOldKodawariStrong } from './entries/three-year-old-kodawari-strong';
import { threeYearsOldEquipment } from './entries/three-years-old-equipment';
import { toddlerBedtime } from './entries/toddler-bedtime';
import { toiletTraining } from './entries/toilet-training';
import { toiletTrainingAge2 } from './entries/toilet-training-age2';
import { toiletTrainingAge3 } from './entries/toilet-training-age3';
import { toiletTrainingNight } from './entries/toilet-training-night';
import { toiletTrainingNotWorking } from './entries/toilet-training-not-working';
import { toiletTrainingPants } from './entries/toilet-training-pants';
import { twinsSoloParenting } from './entries/twins-solo-parenting';
import { twoYearsOldDrawing } from './entries/two-years-old-drawing';
import { twoYearsOldEquipment } from './entries/two-years-old-equipment';
import { whenToStartClay } from './entries/when-to-start-clay';
import { type BlogMetaData } from './types';

export const BLOG_METADATA_ENTRIES: Record<string, BlogMetaData> = {
  toiletTraining,
  readAloudEffect,
  toiletTrainingAge2,
  toiletTrainingAge3,
  toiletTrainingNotWorking,
  playingWithFood,
  toiletTrainingNight,
  concentration,
  oneYearOldPlunk,
  olderSiblingFeelings,
  aboutMontessori,
  babyFollowingUntil,
  curiosity,
  nurseryAdmissionPrep,
  cupDrinkingPractice,
  plannedWeaning,
  clayPlayIdeasAge2,
  independence,
  nurseryTransfer,
  installHomeMonte,
  nurseryMidYearAdmission,
  hoikuen3saiKara,
  newbornBedtime,
  narashiHoikuKikan,
  nurseryVisitQuestions,
  iyaiya,
  placeAnxiety,
  selfCorrection,
  strangerAnxietyWhen,
  oneYearOldEquipment,
  babyFollowingWhen,
  twoYearsOldEquipment,
  chopsticksPractice,
  sessionInformation202310,
  sessionInformation202409,
  sessionInformation202410,
  appearsOnRadio202311,
  oneYearsOldDrawing,
  twoYearsOldDrawing,
  naturalWeaning,
  selfSettlingSleep,
  speechDelayAge2,
  sensitivePeriods,
  pickyEatingChild,
  babyAndMammyReOpening,
  spoonPractice,
  resolvingParentingIssues,
  howToScoldChild,
  peAndEurhymics_202507: peAndEurhymics202507,
  sessionInformation202509,
  sessionInformation202609,
  sessionInformation202610,
  whenToStartClay,
  parentingTired,
  parentingNeurosis,
  soloParentingMontessori,
  parentingConsultation,
  childcareConsultationChat,
  parentingTsurai,
  babyNightCrying,
  bedtimeAge2,
  fourYearOldTantrums,
  tantrum3YearOld,
  nurseryReluctance,
  tantrumsSelfWill,
  toddlerBedtime,
  parentingIraira,
  nurseryCostComparison,
  nurseryUnlicensedDemerit,
  nurseryFeeExemptionUnlicensed,
  nurseryVisitChecklist,
  nurseryRejectionWhatToDo,
  indoorPlay2YearsOld,
  indoorExercisePlayAge1,
  indoorExercisePlayAge2,
  indoorPlay3YearsOld,
  hoikuenErabikata,
  hoikuKyoikuHoushinChigai,
  montessoriHoikuenDemerit,
  hokatsuItsukara,
  hoikuenSagashikata,
  handmadeMontessoriToys,
  hundredYenMontessori,
  threeYearsOldEquipment,
  fourYearsOldEquipment,
  nurseryVisitOutfit,
  napRefusalAge2,
  tantrum2YearOld,
  hoikuenMoushikomiItsukara,
  toiletTrainingPants,
  otetsudaiAge2,
  selfEsteemChild,
  babyNotFollowing,
  twinsSoloParenting,
  separationAnxietyNursery,
  separationAnxietyElementarySchool,
  smallClassNursery,
  hoikuenNaraigoto,
  childPersonalityDiagnosis,
  restless3YearOld,
  threeYearOldKodawariStrong,
  montessoriMathEducationForEducators,
};
